import { Reveal } from "@/components/Reveal";

const stats = [
  { value: "25", suffix: " yrs", label: "In financial services & banking" },
  { value: "260", suffix: "+", label: "Financial literacy sessions led" },
  { value: "6,000", suffix: "+", label: "Investors & students impacted" },
  { value: "3×", suffix: "", label: "CNBC TV18 Best Regional Advisor" },
];

const CredibilityBar = () => (
  <section
    data-testid="credibility-section"
    className="border-y border-border bg-background px-6 py-20 md:px-12 md:py-24"
  >
    <div className="mx-auto max-w-[1400px]">
      <Reveal>
        <p className="text-xs font-bold uppercase tracking-[0.22em] text-accent md:text-sm">
          Track Record
        </p>
      </Reveal>
      <div className="mt-12 grid grid-cols-2 gap-y-12 md:grid-cols-4 md:gap-6">
        {stats.map((s, i) => (
          <Reveal key={s.label} delay={i * 0.08}>
            <div className="border-l border-primary/20 pl-6">
              <p className="font-display text-5xl font-medium leading-none text-primary md:text-7xl">
                {s.value}
                <span className="text-secondary">{s.suffix}</span>
              </p>
              <p className="mt-4 max-w-[14rem] text-sm font-light leading-snug text-foreground/70 md:text-base">
                {s.label}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
      <Reveal delay={0.3}>
        <p className="mt-14 max-w-2xl text-base font-light text-foreground/60 md:text-lg">
          Selected for the Cherie Blair Foundation (UK) under the Goldman Sachs
          10,000 Women Program — a recognition of impact-driven financial education.
        </p>
      </Reveal>
    </div>
  </section>
);

export default CredibilityBar;
